module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-HeavyIt.0d647f24.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/AvenirNextLTPro-HeavyIt.ttf
// module id = 83
// module chunks = 0